export const WORK_AUTHORIZATION_PERMISSION = {
  APPROVE_REJECT: 'urn:replicon:work-authorization-action:approve-reject',
  VIEW_WORK_AUTHORIZATION:
    'urn:replicon:work-authorization-action:view-work-authorization'
};

export const WORK_AUTHORIZATION_DAL = {
  USER: 'urn:replicon:work-authorization-data-access-level:user',
  APPROVER: 'urn:replicon:work-authorization-data-access-level:approver',
  SUPERVISOR: 'urn:replicon:work-authorization-data-access-level:supervisor',
  PROJECT_MANAGER:
    'urn:replicon:work-authorization-data-access-level:project-manager'
};
